
export default {
  name: 'Socials',
  props: {
    isShowNumber: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    socialList() {
      return [
        {
          img: 'WhatsApp',
          link: `https://wa.me/${this.whatsapp}`,
          isShow: Boolean(this.whatsapp),
          number: this.whatsapp || '',
        },
        { img: 'vk', link: '' },
        {
          img: 'telegram',
          link: `https://telegram.me/${this.telegram}`,
          isShow: Boolean(this.telegram),
          number: this.telegram || '',
        },
        { img: 'ok', link: '' },
      ];
    },
    appCfg() {
      return this.$store.getters['appState/config'];
    },
    vars() {
      return this.$store.state?.appState?.vars || {};
    },
    whatsapp() {
      return this.vars.whatsapp || '';
    },
    telegram() {
      return this.appCfg.telegram || '';
    },
  },
};
